<template>
  <div>
    <div class="banner-center">
      <div class="center-container">
        <div class="stable-quicken-box">
          <div class="stable-item">
            <div class="stable-item-img">
              <img src="/static/img/newhome_img/img_earth.png" alt="" />
            </div>
            <div class="stable-item-content">
              <h2 class="stable-title">{{ $t("visitglobal") }}</h2>
              <p class="stable-text">{{ $t("visitcontent1") }}</p>
            </div>
          </div>
          <div class="stable-item">
            <div class="stable-item-img">
              <img src="/static/img/newhome_img/img_safe.png" alt="" />
            </div>
            <div class="stable-item-content">
              <h2 class="stable-title">{{ $t("privacyprotection") }}</h2>
              <p class="stable-text">{{ $t("privacycontent1") }}</p>
            </div>
          </div>
          <div class="stable-item">
            <div class="stable-item-img">
              <img src="/static/img/newhome_img/img_more.png" alt="" />
            </div>
            <div class="stable-item-content">
              <h2 class="stable-title">{{ $t("support") }}</h2>
              <p class="stable-text">{{ $t("supportDes") }}</p>
            </div>
          </div>
        </div>
        <div class="special-box">
          <div class="special-title-box">
            <div class="special-title">{{ $t("specialTitle") }}</div>
            <div class="title-underline"></div>
          </div>
          <div class="special-item-box">
            <div
              class="special-item"
              v-for="(item, index) in $t('specialItem')"
              :key="index"
            >
              <div class="item-title-box">
                <div class="item-ic">
                  <img
                    :src="`/static/img/newhome_img/ic_${index + 1}.svg`"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item-title">{{ item.title }}</div>
              </div>
              <div class="item-content">{{ item.des }}</div>
            </div>
          </div>
        </div>
        <div class="get-plex-box shadow-btn">
          <router-link
            :to="!$store.state.hasToken ? '/register' : '/dashboard'"
            class="get-plex"
            >{{ $t("getPlex") }}</router-link
          >
        </div>
        <div class="global-box">
          <div class="global-title-box">
            <div class="global-title">{{ $t("globalTitle") }}</div>
            <div class="global-des">{{ $t("globalDes") }}</div>
            <div class="title-underline"></div>
          </div>

          <div class="global-gif">
            <img src="/static/img/newhome_img/map@2x.gif" alt="" srcset="" />
          </div>
        </div>
        <div class="user-comments-box">
          <div class="comments-title-box">
            <div class="comments-title">{{ $t("evaluate") }}</div>
            <div class="title-underline"></div>
          </div>
          <!-- Swiper -->
          <div id="swipercom">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in $t('swiperItem')"
                  :key="item.imgSrc + index"
                  :class="`swiper-slide swiper-slide${index + 1}`"
                >
                  <div class="swiper-item">
                    <div class="item-user">
                      <div class="user-img">
                        <img
                          :src="`/static/img/newhome_img/${
                            item.imgSrc + (index + 1)
                          }.png`"
                          alt=""
                          srcset=""
                        />
                      </div>
                      <div class="user-box">
                        <div class="user-title">{{ item.name }}</div>
                        <div class="score">
                          <div class="star-box">
                            <div class="start"></div>
                            <div class="start"></div>
                            <div class="start"></div>
                            <div class="start"></div>
                            <div class="start"></div>
                            <!-- <div class="start-half"></div> -->
                            <!-- <div class="start-null"></div> -->
                          </div>
                          <div class="from">{{ $t("swiperFrom") }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="item-content">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- swiper-pagination -->
              <div class="swiper-pagination"></div>
              <!-- swiper-button-prev -->
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
          <div class="get-plex-box shadow-btn">
            <router-link
              :to="!$store.state.hasToken ? '/register' : '/dashboard'"
              class="get-plex"
              >{{ $t("getPlex") }}</router-link
            >
          </div>
          <div class="packages-title-box">
            <div class="packages-title">{{ $t("enjoy") }}</div>
            <div class="title-underline"></div>
            <div class="days-box">
              <div class="days-icon">
                <img src="/static/img/newhome_img/ic_7-day.svg" alt />
              </div>
              <div class="days-text">{{ $t("vipAdvantage") }}</div>
            </div>
          </div>
        </div>

        <slot></slot>

        <div class="container compatibility">
          <div class="compatibility-title-box">
            <div class="compatibility-title">
              {{ $t("compatibilityTitle") }}
            </div>
            <div class="compatibility-des">
              {{ $t("compatibilityDes") }}
            </div>
          </div>
          <div class="content text-center">
            <div class="download-btn-box">
              <router-link to="/download" class="download-btn">
                <div class="btn-text">{{ $t("download") }}</div>
              </router-link>
            </div>
            <p class="download-more-equipment">
              <router-link
                to="/download?platform=windows"
                class="download-link"
                aria-label="windows"
              >
                <img
                  class="download-icon"
                  src="/static/img/downloadNew/ic_windows.svg"
                  alt=""
                  srcset=""
                />
                <!-- <span
                  ><svg class="icon">
                    <use xlink:href="#icon-windows"></use></svg></span
              > -->
              </router-link>
              <router-link
                to="/download?platform=mac"
                class="download-link"
                aria-label="mac"
                ><img
                  class="download-icon"
                  src="/static/img/downloadNew/ic_macos.svg"
                  alt=""
                  srcset=""
              /></router-link>
              <router-link
                to="/download?platform=ios"
                class="download-link"
                aria-label="ios"
                ><img
                  class="download-icon"
                  src="/static/img/downloadNew/ic_apple.svg"
                  alt=""
                  srcset=""
              /></router-link>
              <router-link
                to="/download?platform=android"
                class="download-link"
                aria-label="android"
                ><img
                  class="download-icon"
                  src="/static/img/downloadNew/ic_android.svg"
                  alt=""
                  srcset=""
              /></router-link>
              <router-link
                to="/download?platform=ubuntu"
                class="download-link"
                aria-label="ubuntu"
                ><img
                  class="download-icon"
                  src="/static/img/downloadNew/ic_linux.svg"
                  alt=""
                  srcset=""
              /></router-link>
              <router-link
                to="/download?platform=androidTV"
                class="download-link"
                aria-label="android_tv"
                ><img
                  class="download-icon"
                  src="/static/img/downloadNew/ic_androidTV.svg"
                  alt=""
                  srcset=""
              /></router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Triangle from "../../../components/triangle/Triangle.vue";
import GradientBtn from "../../../components/gradientBtn/GradientBtn.vue";
import locales from "./lang";
// Import Swiper Vue.js components
// Import Swiper styles
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
// Import Swiper styles
// import "swiper/css";

export default {
  name: "home-body-pc",
  components: {
    Triangle,
    GradientBtn,
  },

  data: function () {
    return {
      isShowHeader: false,
      match: false,
      left: 0,
      boxWidth: 0,
      innerWidth: 0,
      speed: 0,
      lan: "",
      imgdata: {
        zh: [
          "static/img/newhome_img/userwordzh1.png",
          "static/img/newhome_img/userwordzh2.png",
          "static/img/newhome_img/userwordzh3.png",
          "static/img/newhome_img/userwordzh4.png",
          "static/img/newhome_img/userwordzh5.png",
          "static/img/newhome_img/userwordzh6.png",
          "static/img/newhome_img/userwordzh7.png",
        ],
        en: [
          "static/img/newhome_img/userworden1.png",
          "static/img/newhome_img/userworden2.png",
          "static/img/newhome_img/userworden3.png",
          "static/img/newhome_img/userworden4.png",
          "static/img/newhome_img/userworden5.png",
          "static/img/newhome_img/userworden6.png",
          "static/img/newhome_img/userworden7.png",
        ],
      },
      imgs: [
        { pic: "static/img/newhome_img/userwordzh1.png" },
        { pic: "static/img/newhome_img/userwordzh1.png" },
        { pic: "static/img/newhome_img/userwordzh1.png" },
      ],
      // swiper实例  实例上有各种方法
      swiperInstance: null,
      slidesPerView: 3,
    };
  },
  locales,
  computed: {
    mediaType() {
      return this.$store.state.mediaType;
    },
  },
  created() {
    this.match = window.matchMedia("(min-width: 991px)").matches;

    window.addEventListener("scroll", this.showHeader);
  },
  destroyed() {
    window.removeEventListener("scroll", this.showHeader);
  },
  mounted() {
    // this.boxWidth = $(".evaluate-list").eq(1).width();
    // this.innerWidth = $(".evaluate-lists").eq(1).width();

    // var preleft = $(".evaluate-lists").eq(1).find("li").eq(0).offset();
    // var nextleft = $(".evaluate-lists").eq(1).find("li").eq(1).offset();

    // this.speed = nextleft.left - preleft.left;
    // setInterval(
    //   this.shownext()
    // , 3000)

    this.lan = window.localStorage.getItem("currentLang");
    this.slidesPerView = document.documentElement.clientWidth >= 991 ? 3 : 1;

    this.$nextTick(() => {
      let mySwiper = new Swiper(".swiper-container", {
        loop: true,
        slidesPerView: this.slidesPerView,
        resizeObserver: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          resize: function () {
            this.params.slidesPerView =
              document.documentElement.clientWidth >= 991 ? 3 : 1;
            this.update();
          },
        },
        // slidesOffsetBefore: 90,
        centeredSlides: true,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });
  },
  methods: {
    showHeader: function () {
      if ($(window).scrollTop() >= 600) {
        this.isShowHeader = true;
        this.$store.commit("setPhoneHeaderLogoFlag", true);
      } else {
        this.isShowHeader = false;
        this.$store.commit("setPhoneHeaderLogoFlag", false);
      }
    },
    showpre: function () {
      var limit = this.speed - $(".evaluate-lists").eq(1).find("li").width();
      this.left += this.speed;
      if (this.left >= limit) {
        this.left = 0;
      }
    },
    shownext: function () {
      var limit = this.speed - $(".evaluate-lists").eq(1).find("li").width();
      this.left -= this.speed;
      if (this.left <= this.boxWidth - this.innerWidth - limit) {
        this.left = this.boxWidth - this.innerWidth;
      }
    },
    getNow: function () {
      // Jump to dashboard after logging in, else login
      if (this.$store.state.hasToken) {
        this.$router.push("/dashboard");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// @import "homeBodyPc";

.banner-center {
  background: #fff;
  p {
    margin: 0;
    padding: 0;
  }
  .center-container {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;

    .title-underline {
      width: 60px;
      height: 4px;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      margin: 0 auto;
      margin-top: 24px;
    }
    .stable-quicken-box {
      width: fit-content;
      margin: 0 auto;
      max-width: 100%;
      padding-top: 180px;
      .stable-item {
        width: 100%;
        margin-bottom: 120px;
        display: flex;
        align-items: center;
        &:nth-child(2) {
          flex-direction: row-reverse;
          .stable-item-img {
            margin-right: 0;
            margin-left: 100px;
          }
        }
        .stable-item-img {
          width: 530px;
          height: 530px;
          text-align: center;
          margin-right: 100px;
          img {
            width: 530px;
            height: 100%;
            object-fit: contain;
            margin: 0 auto;
          }
        }
        .stable-item-content {
          width: 550px;
          .stable-title {
            font-size: 40px;
            color: #111111;
            letter-spacing: 0;
            line-height: 54px;
            font-weight: 600;
            margin-top: 0;
            margin-bottom: 24px;
          }
          .stable-text {
            font-size: 20px;
            color: #666666;
            line-height: 30px;
            font-weight: 400;
          }
        }
      }
    }
    .special-box {
      .special-title-box {
        padding-top: 60px;
        .special-title {
          font-size: 40px;
          color: #111111;
          letter-spacing: 2px;
          text-align: center;
          line-height: 40px;
          font-weight: 600;
        }
      }
      .special-item-box {
        width: 1180px;
        margin: 0 auto;
        margin-top: 80px;
        display: flex;
        flex-wrap: wrap;

        .special-item {
          width: 340px;
          margin-right: 80px;
          text-align: center;
          margin-bottom: 84px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          &:nth-last-child(-n + 3) {
            margin-bottom: 0;
          }
          .item-ic {
            margin-bottom: 16px;
            img {
              width: 50px;
              height: 50px;
              object-fit: contain;
            }
          }
          .item-title {
            font-size: 24px;
            color: #333333;
            line-height: 32px;
            font-weight: 600;
            margin-bottom: 8px;
          }
          .item-content {
            font-size: 16px;
            color: #666666;
            line-height: 24px;
            font-weight: 400;
          }
        }
      }
    }
    .get-plex-box {
      margin-top: 64px;
      .get-plex {
        display: block;
        width: 350px;
        height: 66px;
        line-height: 66px;
        margin: 0 auto;
        background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
        border-radius: 100px;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        font-weight: 600;
      }
    }
    .shadow-btn {
      .get-plex {
        position: relative;
        z-index: 0;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
        &:hover {
          &::before {
            content: "";
            width: 100%;
            height: 100%;
            background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
            border-radius: 100px;
            filter: blur(8px);
            -webkit-filter: blur(8px);
            -moz-filter: blur(8px);
            -ms-filter: blur(8px);
            -o-filter: blur(8px);
            position: absolute;
            top: 8px;
            left: 0;
            z-index: -1;
          }
        }
      }
    }
    .global-box {
      text-align: center;
      .global-title-box {
        width: 1000px;
        margin: 180px auto 80px auto;
        .global-title {
          font-size: 40px;
          color: #111111;
          letter-spacing: 2px;
          line-height: 40px;
          font-weight: 600;
          margin-bottom: 24px;
        }
        .global-des {
          font-size: 16px;
          color: #999999;
          letter-spacing: 0;
          line-height: 24px;
          font-weight: 400;
          margin-bottom: 24px;
        }
      }
      .global-gif {
        width: 1092px;
        height: 529px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .user-comments-box {
      padding: 150px 0 100px 0;
      margin: -150px auto -100px 0;
      background: url("/static/img/newhome_img/bg.png") 100% 100% no-repeat;
      background-size: 100% 100%;
      position: relative;
      z-index: 1;
      .packages-title-box {
        padding-top: 180px;
        text-align: center;
        display: block;
        .packages-title {
          font-size: 40px;
          color: #111111;
          letter-spacing: 2px;
          line-height: 40px;
          font-weight: 600;
        }
        .title-underline {
          width: 60px;
          height: 4px;
          background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
          margin: 0 auto;
          margin-top: 24px;
        }
        .days-box {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
          .days-icon {
            width: 16px;
            height: 16px;
            // line-height: 20px;
            margin-right: 8px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              vertical-align: baseline;
            }
          }
          .days-text {
            font-size: 16px;
            color: #666666;
            letter-spacing: 0;
            // line-height: 20px;
            font-weight: 400;
          }
        }
      }
      .comments-title-box {
        margin: 180px 0 80px;
        text-align: center;
        .comments-title {
          font-size: 40px;
          color: #111111;
          letter-spacing: 2px;
          line-height: 40px;
          font-weight: 600;
          margin-bottom: 24px;
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        width: 70px;
        height: 70px;
        outline: 0;

        &::after {
          content: "";
        }
        &:focus-visible {
          outline: 0;
        }
      }

      .swiper-button-next {
        background: url("/static/img/newhome_img/ic_right.png") 100% 100%
          no-repeat;
        background-size: 100% 100%;
        right: 0;
        &:hover {
          background-image: url("/static/img/newhome_img/ic_right_hover.png");
        }
      }
      .swiper-button-prev {
        background: url("/static/img/newhome_img/ic_left.png") 100% 100%
          no-repeat;
        background-size: 100% 100%;
        left: 0;
        &:hover {
          background-image: url("/static/img/newhome_img/ic_left_hover.png");
        }
      }

      #swipercom {
        margin: 0 auto;

        .swiper-container {
          width: 1258px;
          padding: 0 16px;
          height: 376px;
          margin-top: -50px;
          .swiper-slide {
            width: 375px;
          }
          .swiper-slide img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .swiper-item {
            width: 375px;
            height: 276px;
            margin: 0 auto;
            background: #ffffff;
            border: 1px solid rgba(224, 215, 227, 1);
            border-radius: 8px;
            padding: 32px;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            .item-user {
              display: flex;
              .user-img {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                margin-right: 16px;
              }
              .user-box {
                .user-title {
                  height: 22px;
                  overflow: hidden;
                  font-size: 18px;
                  line-height: 22px;
                  color: #333333;
                  font-weight: 400;
                  margin-bottom: 4px;
                }
                .score {
                  display: flex;
                  .star-box {
                    display: flex;
                    > div {
                      width: 18px;
                      height: 18px;
                    }
                    .start {
                      background: url("/static/img/newhome_img/ic_star_1.svg")
                        100% 100% no-repeat;
                      background-size: 100% 100%;
                    }
                    .start-half {
                      background: url("/static/img/newhome_img/ic_star_0.5.svg")
                        100% 100% no-repeat;
                      background-size: 100% 100%;
                    }
                    .start-null {
                      background: url("/static/img/newhome_img/ic_star_0.svg")
                        100% 100% no-repeat;
                      background-size: 100% 100%;
                    }
                  }
                }
                .from {
                  font-size: 14px;
                  line-height: 22px;
                  font-weight: 400;
                  margin-left: 8px;
                  color: #999999;
                }
              }
            }
            .item-content {
              height: 140px;
              overflow-y: hidden;
              font-size: 18px;
              color: #666666;
              line-height: 28px;
              font-weight: 400;
              margin-top: 24px;
              scrollbar-width: thin;
              scrollbar-color: #e0e0e0 #fff;
              &::-webkit-scrollbar {
                width: 3px;
                background: #fff;
              }
              &::-webkit-scrollbar-thumb {
                width: 3px;
                background: #e0e0e0;
                border-radius: 1px;
              }
            }
          }
        }
      }
    }
    .compatibility {
      background: #fff;
      .compatibility-title-box {
        text-align: center;
        margin: 170px auto 40px auto;
        .compatibility-title {
          font-size: 40px;
          color: #111111;
          letter-spacing: 0;
          line-height: 48px;
          font-weight: 600;
          margin-bottom: 24px;
        }
        .compatibility-des {
          width: 1033px;
          margin: 0 auto;
          font-size: 20px;
          color: #666666;
          letter-spacing: 0;
          line-height: 30px;
          font-weight: 400;
        }
      }
      .text-center {
        margin: 0 auto;
        .download-btn-box {
          width: 352px;
          height: 68px;
          padding: 1px;
          margin: 0 auto;
          border-radius: 100px;
          background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
          .download-btn {
            display: block;
            width: 350px;
            height: 66px;
            line-height: 66px;
            border-radius: 100px;
            background-image: linear-gradient(125deg, #f3f3ff 0%, #fcf2ff 100%);
            margin: 0 auto;
            font-size: 24px;
            color: #333333;
            text-align: center;
            font-weight: 600;
            .btn-text {
              width: fit-content;
              margin: 0 auto;
              background-image: linear-gradient(
                125deg,
                #416cf8 0%,
                #ec55ff 100%
              );

              // background-image: -webkit-linear-gradient(
              //   left top,
              //   #416cf8,
              //   #ec55ff
              // );
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }
      }

      .download-more-equipment {
        margin: 48px 0 180px 0;
        .download-link {
          &:not(:last-child) {
            margin-right: 32px;
          }
          .download-icon {
            width: 32px;
            height: 32px;
            object-fit: contain;
          }
        }
        a {
          &:first-child img:hover {
            content: url(/static/img/downloadNew/ic_windows_hover.svg);
          }
          &:nth-child(2) img:hover {
            content: url(/static/img/downloadNew/ic_macos_hover.svg);
          }
          &:nth-child(3) img:hover {
            content: url(/static/img/downloadNew/ic_apple_hover.svg);
          }
          &:nth-child(4) img:hover {
            content: url(/static/img/downloadNew/ic_android_hover.svg);
          }
          &:nth-child(5) img:hover {
            content: url(/static/img/downloadNew/ic_linux_hover.svg);
          }
          &:nth-child(6) img:hover {
            content: url(/static/img/downloadNew/ic_androidTV_hover.svg);
          }
        }
      }
    }
  }
}
@media (max-width: 1228px) {
  .banner-center .center-container {
    .stable-quicken-box .stable-item {
      padding: 0 24px;
    }
    .special-box .special-item-box {
      width: 100%;
      padding: 0 24px;
      justify-content: space-between;
      .special-item {
        width: 30%;
        margin-right: 0;
      }
    }
    .global-box .global-gif {
      width: 100%;
      height: auto;
      padding: 0 24px;
    }
    .user-comments-box {
      #swipercom .swiper-container {
        width: 100%;
        padding: 0 24px;
        .swiper-item {
          width: 86%;
          height: auto;
          padding: 12px;
        }
      }
      .swiper-button-prev {
        width: 50px;
        height: 50px;
        left: 24px;
      }
      .swiper-button-next {
        width: 50px;
        height: 50px;
        right: 24px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .banner-center {
    .center-container {
      .title-underline {
        margin-top: 16px;
        width: 40px;
      }
      .stable-quicken-box {
        padding-top: 80px;
        .stable-item {
          flex-direction: column;
          margin-bottom: 80px;
          &:nth-child(1) {
            .stable-item-img {
              img {
                content: url("/static/img/newhome_img/img_earth_h5.png");
              }
            }
          }
          &:nth-child(2) {
            flex-direction: column;
            .stable-item-img {
              margin: 0 auto;
              img {
                content: url("/static/img/newhome_img/img_safe_h5.png");
              }
            }
          }
          &:nth-child(3) {
            .stable-item-img {
              img {
                content: url("/static/img/newhome_img/img_more_h5.png");
              }
            }
          }
          .stable-item-img {
            width: 300px;
            height: 300px;
            margin: 0 auto;
            img {
              width: 300px;
            }
          }
          .stable-item-content {
            width: 327px;
            text-align: center;
            padding: 0 24px;
            .stable-title {
              font-size: 24px;
              line-height: 32px;
              margin-bottom: 16px;
              margin-top: -40px;
            }
            .stable-text {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
      .special-box {
        .special-title-box {
          padding: 0 24px;
          .special-title {
            font-size: 24px;
            line-height: 32px;
            letter-spacing: 0;
          }
        }
        .special-item-box {
          width: 100%;
          padding: 0 24px;
          justify-content: space-between;
          margin-top: 40px;
          .special-item {
            width: 300px;
            margin-right: 0;
            margin-bottom: 40px;
            .item-title-box {
              .item-ic {
                margin-bottom: 24px;
                height: 64px;
                img {
                  width: 64px;
                  max-height: 100%;
                }
              }
              .item-title {
                font-size: 18px;
                line-height: 24px;
              }
            }
            .item-content {
              font-size: 14px;
              line-height: 20px;
            }
            &:nth-last-child(-n + 3) {
              margin-bottom: 40px;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .get-plex-box {
        margin-top: 40px;
        .get-plex {
          width: 260px;
          height: 49px;
          line-height: 49px;
          font-size: 16px;
        }
      }
      .global-box {
        .global-title-box {
          width: 327px;
          margin: 80px auto 40px auto;
          padding: 0 24px;
          .global-title {
            font-size: 24px;
            letter-spacing: 0;
            line-height: 32px;
            margin-bottom: 16px;
          }
          .global-des {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 16px;
          }
        }
        .global-gif {
          width: 327px;
          height: 160px;
          margin: 0 auto;
          padding: 0 24px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
      .user-comments-box {
        background: url("/static/img/newhome_img/bg_h5.png") 100% 100% no-repeat;
        background-size: 100% 100%;
        padding: 0;
        margin: auto;
        .packages-title-box {
          padding: 80px 24px 0;
          .packages-title {
            font-size: 24px;
            letter-spacing: 0;
            line-height: 32px;
          }
          .title-underline {
            margin-top: 16px;
            width: 40px;
          }
          .days-box {
            .days-icon {
              width: 14px;
            }
            .days-text {
              font-size: 14px;
            }
          }
        }
        .comments-title-box {
          margin: 80px 0 40px;
          text-align: center;
          .comments-title {
            font-size: 24px;
            letter-spacing: 0;
            line-height: 32px;
            margin-bottom: 16px;
          }
        }
        .swiper-button-next,
        .swiper-button-prev {
          width: 28px;
          height: 28px;
          top: 53%;
        }
        .swiper-button-next {
          right: 14px;
        }
        .swiper-button-prev {
          left: 14px;
        }
        #swipercom {
          margin: 0 auto;
          .swiper-container {
            width: 100%;
            padding: 0 12px;
            height: 292px;
            margin-top: -40px;
            .swiper-slide {
              // width: 303px !important;
            }

            .swiper-item {
              width: 303px;
              height: 212px;
              padding: 24px 16px;
              .item-user {
                .user-box {
                  .user-title {
                    margin-bottom: 5px;
                  }
                  .score {
                    .star-box {
                      > div {
                        width: 15px;
                        height: 15px;
                      }
                    }
                  }
                  .from {
                    font-size: 12px;
                    line-height: 16px;
                    margin-left: 5px;
                  }
                }
              }
              .item-content {
                height: 100px;
                font-size: 14px;
                line-height: 20px;
                margin-top: 16px;
              }
            }
          }
        }
      }
      .compatibility {
        .compatibility-title-box {
          margin: 70px 9px 40px;
          .compatibility-title {
            font-size: 24px;
            letter-spacing: 0;
            line-height: 32px;
          }
          .compatibility-des {
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            width: 100%;
          }
        }
        .text-center {
          width: 100%;
          .download-btn-box {
            width: 260px;
            height: 49px;
            .download-btn {
              width: 258px;
              height: 47px;
              line-height: 47px;
              .btn-text {
                font-size: 16px;
              }
            }
          }
        }

        .download-more-equipment {
          width: auto;
          max-width: 100%;
          padding: 0;
          margin: 40px auto 80px auto;
          display: flex;
          justify-content: center;
          flex-wrap: nowrap;
          .download-link {
            &:not(:last-child) {
              margin-right: 27px;
            }
            .download-icon {
              padding: 0;
              width: 32px;
              height: 32px;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .banner-center .center-container {
    margin-top: 50px;
  }
  .banner-center .center-container .user-comments-box #swipercom .swiper-container .swiper-item {
    width: 96%;
  }
  .banner-center .center-container .user-comments-box .swiper-button-prev {
    left: 2%;
  }
  .banner-center .center-container .user-comments-box .swiper-button-next {
    right: 2%;
  }
  .banner-center .center-container .special-box .special-item-box {
    justify-content: center;
  }
  .banner-center .center-container .compatibility .download-more-equipment {
    justify-content: space-between;
    padding: 0 9px;
  }
  .banner-center .center-container .compatibility .download-more-equipment .download-link:not(:last-child) {
    margin-right: 0;
  }
}
</style>
<style lang="scss">
.swiper-pagination {
  .swiper-pagination-bullet {
    background: rgba(0, 0, 0, 0.16);
    opacity: 1;
    vertical-align: middle;
    outline: 0;
    &:focus-visible {
      outline: 0;
    }
  }
  .swiper-pagination-bullet-active {
    width: 12px;
    height: 12px;
    background: #999999 !important;
  }
}
@media (max-width: 991px) {
  .swiper-pagination {
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
    }
    .swiper-pagination-bullet-active {
      width: 8px;
      height: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// HomeBodyPc.vue?f8da020c